export const LIST_COUNTRY_REQUEST = 'LIST_COUNTRY_REQUEST'
export const LIST_COUNTRY_SUCCESS = 'LIST_COUNTRY_SUCCESS'
export const LIST_COUNTRY_FAIL = 'LIST_COUNTRY_FAIL'

export const LIST_PROVINCE_REQUEST = 'LIST_PROVINCE_REQUEST'
export const LIST_PROVINCE_SUCCESS = 'LIST_PROVINCE_SUCCESS'
export const LIST_PROVINCE_FAIL = 'LIST_PROVINCE_FAIL'

export const LIST_CITY_REQUEST = 'LIST_CITY_REQUEST'
export const LIST_CITY_SUCCESS = 'LIST_CITY_SUCCESS'
export const LIST_CITY_FAIL = 'LIST_CITY_FAIL'

export const LIST_SUBDISTRICT_REQUEST = 'LIST_SUBDISTRICT_REQUEST'
export const LIST_SUBDISTRICT_SUCCESS = 'LIST_SUBDISTRICT_SUCCESS'
export const LIST_SUBDISTRICT_FAIL = 'LIST_SUBDISTRICT_FAIL'

export const LIST_VILLAGE_REQUEST = 'LIST_VILLAGE_REQUEST'
export const LIST_VILLAGE_SUCCESS = 'LIST_VILLAGE_SUCCESS'
export const LIST_VILLAGE_FAIL = 'LIST_VILLAGE_FAIL'
